module.exports = __webpack_public_path__ + "img/plus_3_5_tonnes.517bf0f8.png";